module.exports = __webpack_public_path__ + "img/help-points.b3cbd16a.jpg";